export default {
  // 国内：正式环境：ota.rayneo.cn测试环境：ota-test.rayneo.cn
  // 海外：正式环境：ota.rayneo.com测试环境：ota-hw-test.rayneo.cn

  tadPath:
    location.hostname === "ota.rayneo.cn"
      ? "https://tdp-o.api.leiniao.com"
      : location.hostname === "ota.rayneo.com"
      ? "https://hw-tdp-o.api.leiniao.com"
      : location.hostname === "ota-test.rayneo.cn"
      ? "https://tdp-t.api.leiniao.com"
      : location.hostname === "ota-hw-test.rayneo.cn"
      ? "https://tdp-t.api.leiniao.com"
      : location.hostname === "localhost"
      ? ""
      : "https://tdp-t.api.leiniao.com",
  xrlauncherPath:
    location.hostname === "ota.rayneo.cn"
      ? "https://xrlauncher-o.api.leiniao.com"
      : location.hostname === "ota.rayneo.com"
      ? "https://hwxr-o.api.leiniao.com"
      : location.hostname === "ota-test.rayneo.cn"
      ? "https://test.launcher.tcloudfamily.com"
      : location.hostname === "ota-hw-test.rayneo.cn"
      ? "https://test-xr-launcherapi.rayneo.cn"
      : location.hostname === "localhost"
      ? ""
      : "https://test.launcher.tcloudfamily.com",
  path:
    location.hostname === "ota.rayneo.cn"
      ? "https://rayneo.cn"
      : location.hostname === "ota.rayneo.com"
      ? "https://rayneo.com"
      : location.hostname === "ota-test.rayneo.cn"
      ? "https://test.rayneo.cn"
      : location.hostname === "ota-hw-test.rayneo.cn"
      ? "https://test.rayneo.com"
      : location.hostname === "localhost"
      ? ""
      : "https://test.rayneo.cn",
};
